import { REDUX_STORE } from '@funnels/constants';
import {
  ClearPostProductSelectErrorAction,
  FetchPostProductSelectAction,
  FetchPostProductSelectFailAction,
  FetchPostProductSelectSuccessAction,
  PostProductSelectContract,
} from '@funnels/types';

export function clearPostProductSelectError(): ClearPostProductSelectErrorAction {
  return { type: REDUX_STORE.POST_PRODUCT_SELECT.ACTION_TYPES.CLEAR_POST_PRODUCT_SELECT_ERROR };
}

export function fetchPostProductSelect(applicationId: string): FetchPostProductSelectAction {
  return {
    type: REDUX_STORE.POST_PRODUCT_SELECT.ACTION_TYPES.FETCH_POST_PRODUCT_SELECT,
    applicationId,
  };
}

export function fetchPostProductSelectFail(message: string = 'Unknown error'): FetchPostProductSelectFailAction {
  return { type: REDUX_STORE.POST_PRODUCT_SELECT.ACTION_TYPES.FETCH_POST_PRODUCT_SELECT_FAIL, message };
}

export function fetchPostProductSelectSuccess(
  contract: PostProductSelectContract[]
): FetchPostProductSelectSuccessAction {
  return { type: REDUX_STORE.POST_PRODUCT_SELECT.ACTION_TYPES.FETCH_POST_PRODUCT_SELECT_SUCCESS, contract };
}
